import { useMountEffect } from "@react-hookz/web";
import { useNavigate } from "react-router";

import type { FC } from "react";

const EmailDomainConfigurationPage: FC = () => {
  const navigate = useNavigate();

  useMountEffect(() => {
    void navigate("/manage/channels/email", { replace: true });
  });

  return <></>;
};

export default EmailDomainConfigurationPage;
